import Document from "screens/private/document";
export default Document;
